import React, { FunctionComponent } from 'react'

const StatusBarInProgressIcon: FunctionComponent = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2305_37062)">
        <path
          d="M30.9678 58.0636C46.4717 58.0636 59.0401 45.4952 59.0401 29.9913C59.0401 14.4874 46.4717 1.91895 30.9678 1.91895C15.4639 1.91895 2.89551 14.4874 2.89551 29.9913C2.89551 45.4952 15.4639 58.0636 30.9678 58.0636Z"
          fill="#FDE5D1"
        />
        <path
          d="M30.9678 54.1905C44.3327 54.1905 55.1671 43.3561 55.1671 29.9913C55.1671 16.6264 44.3327 5.79199 30.9678 5.79199C17.6029 5.79199 6.76855 16.6264 6.76855 29.9913C6.76855 43.3561 17.6029 54.1905 30.9678 54.1905Z"
          fill="#FCCDA7"
        />
        <path
          d="M30.9677 41.6073C37.3828 41.6073 42.5833 36.4068 42.5833 29.9916C42.5833 23.5765 37.3828 18.376 30.9677 18.376C24.5526 18.376 19.3521 23.5765 19.3521 29.9916C19.3521 36.4068 24.5526 41.6073 30.9677 41.6073Z"
          fill="#F8B883"
        />
        <path
          d="M30.9678 29.9921V0.975859C30.9678 0.432108 30.518 -0.0171899 29.9746 0.000505448C13.1631 0.547069 -0.152468 14.9221 1.03347 32.1201C2.05804 46.9794 14.1405 58.9916 29.005 59.9375C37.7044 60.4911 45.6709 57.3352 51.4755 51.8991C51.8719 51.528 51.8708 50.8951 51.4869 50.5112L30.9678 29.9921Z"
          fill="#F8B883"
        />
        <path
          d="M30.9679 29.9918V5.79199C17.6027 5.79199 6.76807 16.6267 6.76807 29.9918C6.76807 43.357 17.6027 54.1918 30.9679 54.1918C37.6506 54.1918 43.7005 51.4831 48.0798 47.1038L30.9679 29.9918Z"
          fill="#D29664"
        />
        <path
          d="M39.1817 38.2057L30.968 29.992V18.376C24.5527 18.376 19.3521 23.5765 19.3521 29.992C19.3521 36.4073 24.5526 41.608 30.968 41.608C34.1756 41.6079 37.0796 40.3077 39.1817 38.2057Z"
          fill="#B96C2D"
        />
        <path
          d="M39.6798 44.5126V39.3404C39.6798 38.3135 39.2719 37.3286 38.5458 36.6025L33.9893 32.046C32.8553 30.912 32.8553 29.0732 33.9893 27.9392L38.5458 23.3827C39.2719 22.6566 39.6798 21.6718 39.6798 20.6449V15.4727H22.2559V20.6449C22.2559 21.6718 22.6638 22.6566 23.3899 23.3827L27.9464 27.9392C29.0804 29.0732 29.0804 30.912 27.9464 32.046L23.3899 36.6025C22.6638 37.3286 22.2559 38.3135 22.2559 39.3404V44.5126"
          fill="white"
        />
        <path
          d="M39.6799 17.4086V15.4727H22.256V20.6449C22.256 21.6718 22.6639 22.6566 23.39 23.3827L27.9464 27.9391C29.0804 29.0731 29.0804 30.9119 27.9464 32.0459L23.3899 36.6024C22.6638 37.3285 22.2559 38.3135 22.2559 39.3404V44.5125H28.0638V39.3404C28.0638 38.3135 28.1999 37.3286 28.4418 36.6025L29.9607 32.046C30.3371 30.9167 30.3371 29.0687 29.9607 27.9392L28.4418 23.3827C28.1999 22.6565 28.0638 21.6717 28.0638 20.6449V18.8607C28.0638 18.0588 28.7138 17.4087 29.5158 17.4087L39.6799 17.4086Z"
          fill="#FDF3E8"
        />
        <path
          d="M37.177 37.9707L36.5413 37.3349C36.1782 36.9718 35.6857 36.7678 35.1722 36.7678H33.872C32.8027 36.7678 31.936 35.901 31.936 34.8318V27.5388C31.936 27.2752 32.0435 27.0231 32.2336 26.8406L35.1478 24.042C35.4527 23.7372 35.2367 23.2158 34.8056 23.2158H27.1304C26.6992 23.2158 26.4833 23.7372 26.7882 24.042L29.7024 26.8406C29.8925 27.0231 30 27.2752 30 27.5388V34.8318C30 35.901 29.1332 36.7678 28.064 36.7678H26.7637C26.2503 36.7678 25.7579 36.9718 25.3947 37.3348L24.7588 37.9707C24.3958 38.3337 24.1919 38.8262 24.1919 39.3396V41.6077C24.1919 42.1423 24.6253 42.5757 25.1599 42.5757H36.7759C37.3105 42.5757 37.7438 42.1423 37.7438 41.6077V39.3394C37.744 38.826 37.5399 38.3337 37.177 37.9707Z"
          fill="#F8B883"
        />
        <path
          d="M26.7883 24.042L29.5443 26.6887L28.442 23.3819C28.425 23.3308 28.4126 23.2694 28.3967 23.2158H27.1305C26.6992 23.2158 26.4833 23.7372 26.7883 24.042Z"
          fill="#E0B28C"
        />
        <path
          d="M28.0639 39.3398C28.0639 38.3702 28.1887 37.4457 28.406 36.7334C28.2945 36.7533 28.1811 36.7678 28.0639 36.7678H26.7636C26.2502 36.7678 25.7578 36.9718 25.3947 37.3349L24.7588 37.9708C24.3958 38.3338 24.1919 38.8263 24.1919 39.3397V41.6078C24.1919 42.1424 24.6253 42.5758 25.1599 42.5758H28.0639V39.3398Z"
          fill="#E0B28C"
        />
        <path
          d="M39.68 15.4725H22.2561C21.7214 15.4725 21.2881 15.0391 21.2881 14.5045V12.5686C21.2881 12.0339 21.7214 11.6006 22.2561 11.6006H39.68C40.2146 11.6006 40.648 12.0339 40.648 12.5686V14.5045C40.648 15.0391 40.2146 15.4725 39.68 15.4725Z"
          fill="#BBBBBB"
        />
        <path
          d="M28.0641 14.5045V12.5686C28.0641 12.0339 28.4975 11.6006 29.0321 11.6006H22.2561C21.7214 11.6006 21.2881 12.0339 21.2881 12.5686V14.5045C21.2881 15.0391 21.7214 15.4725 22.2561 15.4725H29.0321C28.4975 15.4725 28.0641 15.0391 28.0641 14.5045Z"
          fill="#767676"
        />
        <path
          d="M39.68 48.3836H22.2561C21.7214 48.3836 21.2881 47.9502 21.2881 47.4156V45.4797C21.2881 44.9451 21.7214 44.5117 22.2561 44.5117H39.68C40.2146 44.5117 40.648 44.9451 40.648 45.4797V47.4156C40.648 47.9502 40.2146 48.3836 39.68 48.3836Z"
          fill="#BBBBBB"
        />
        <path
          d="M28.0641 47.4156V45.4797C28.0641 44.9451 28.4975 44.5117 29.0321 44.5117H22.2561C21.7214 44.5117 21.2881 44.9451 21.2881 45.4797V47.4156C21.2881 47.9502 21.7214 48.3836 22.2561 48.3836H29.0321C28.4975 48.3836 28.0641 47.9502 28.0641 47.4156Z"
          fill="#767676"
        />
      </g>
      <defs>
        <clipPath id="clip0_2305_37062">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StatusBarInProgressIcon
